import "@arco-design/web-react/es/Space/style";
import _Space from "@arco-design/web-react/es/Space";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import _IconLock from "@arco-design/web-react/icon/react-icon/IconLock";
import "@arco-design/web-react/es/Form/style";
import _Form from "@arco-design/web-react/es/Form";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import _IconUser from "@arco-design/web-react/icon/react-icon/IconUser";
import React, { useRef, useState } from 'react';
import styles from './style/index.module.less';
import { Login } from "@/utils/api";
export default function LoginForm() {
  const formRef = useRef();
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  function login(params) {
    setErrorMessage('');
    setLoading(true);
    Login(params).then(res => {
      //{
      //     "code": 0,
      //     "msg": "登录成功",
      //     "data": {
      //         "token": "itegd7MidLkKdm9tSvEzNxPEZfkdCW4dYQVnlacHj7eT2tIlUs7lTqHyRGAcv2NZ",
      //         "user": {
      //             "id": 1,
      //             "username": "admin"
      //         }
      //     }
      // }
      const {
        code,
        data,
        msg
      } = res;
      if (code === 0) {
        // 记录登录状态
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        // 跳转首页
        window.location.href = '/index';
      } else {
        setErrorMessage(msg);
      }
    }).finally(() => {
      setLoading(false);
    });
  }
  function onSubmitClick() {
    formRef.current.validate().then(values => {
      login(values);
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-title']
  }, "\u62DB\u751F\u62A5\u540D\u7CFB\u7EDF\u767B\u5F55"), /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-error-msg']
  }, errorMessage), /*#__PURE__*/React.createElement(_Form, {
    className: styles['login-form'],
    layout: "vertical",
    ref: formRef
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    field: "username",
    rules: [{
      required: true
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    prefix: /*#__PURE__*/React.createElement(_IconUser, null),
    autoComplete: "off"
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    field: "password",
    rules: [{
      required: true
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, {
    prefix: /*#__PURE__*/React.createElement(_IconLock, null),
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Space, {
    size: 16,
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(_Button, {
    type: "primary",
    long: true,
    onClick: onSubmitClick,
    loading: loading
  }, "\u767B\u5F55"))));
}